var _regeneratorRuntime = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/token-display-app/node_modules/@babel/runtime/helpers/createClass.js");

/*
  This library is used to create mutable and immutable data, and to update the
  mutable data associated with a token.

  Primary functions:

  - createTokenData() - is used to get the IPFS CID representing data that goes
    into the mutable and immutable data of the token.

  - writeCIDToOpReturn() - is used to update mutable data by writing a new
    pointer to the Mutable Data Address (MDA) on the BCH blockchain.
*/
// Public npm libraries
var _require = require('p2wdb'),
    Pin = _require.Pin,
    Write = _require.Write;

var RetryQueue = require('@chris.troutner/retry-queue-commonjs');

var Data = /*#__PURE__*/function () {
  "use strict";

  function Data() {
    var localConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Data);

    // Dependency injection
    this.wallet = localConfig.wallet;

    if (!this.wallet) {
      throw new Error('Instance of minimal-slp-wallet must be passed as wallet when instantiating this library.');
    } // Allow user to specify P2WDB server at run-time.


    this.serverURL = 'https://p2wdb.fullstack.cash'; // this.serverURL = 'https://p2wdb.fullstackcash.nl'
    // this.serverURL = 'http://localhost:5010'

    if (localConfig.serverURL) this.serverURL = localConfig.serverURL; // Allow user to specify Pinning service at run-time.

    this.pinServer = 'https://p2wdb-pin.fullstack.cash'; // this.pinServer = 'http://localhost:5021'

    if (localConfig.pinServer) this.pinServer = localConfig.pinServer; // Encapsulate dependencies

    this.bchjs = this.wallet.bchjs;
    this.write = new Write({
      bchWallet: this.wallet,
      serverURL: this.serverURL
    });
    this.pin = new Pin({
      bchWallet: this.wallet,
      serverURL: this.serverURL,
      pinServer: this.pinServer
    });
    this.retryQueue = new RetryQueue({
      attempts: 3,
      retryPeriod: 1000
    }); // Bind 'this' object to functions that lose context.

    this.writeJsonToP2wdb = this.writeJsonToP2wdb.bind(this);
    this.pinJson = this.pinJson.bind(this);
    this.createTokenData = this.createTokenData.bind(this);
    this.writeCIDToOpReturn = this.writeCIDToOpReturn.bind(this);
  } // This function will pin an arbitrary object to IPFS using the P2WDB
  // pinning service. It will convert the object to JSON, upload it to P2WDB,
  // then ask the pinning cluster to pin the JSON. This function will return
  // the IPFS CID of the pinned JSON object.
  //
  // This function is useful for generating mutable and immutable data prior
  // to creating a token.
  //
  // This function uses the retry-queue to automatically retry if there
  // is a network communcation issue.


  _createClass(Data, [{
    key: "createTokenData",
    value: function () {
      var _createTokenData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(inObj) {
        var zcid, inObj2, _yield$this$retryQueu, ipfsCid;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.retryQueue.addToQueue(this.writeJsonToP2wdb, inObj);

              case 3:
                zcid = _context.sent;
                console.log('createTokenData() zcid: ', zcid);
                inObj2 = {
                  zcid: zcid
                }; // Pin the JSON data to IPFS

                _context.next = 8;
                return this.retryQueue.addToQueue(this.pinJson, inObj2);

              case 8:
                _yield$this$retryQueu = _context.sent;
                ipfsCid = _yield$this$retryQueu.ipfsCid;
                console.log('createTokenData() ipfsCid: ', ipfsCid); // console.log('createTokenData() p2wdbPinCid: ', p2wdbPinCid)

                return _context.abrupt("return", ipfsCid);

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);
                console.error('Error in slp-mutable-data/data.js createTokenData()');
                throw _context.t0;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      function createTokenData(_x) {
        return _createTokenData.apply(this, arguments);
      }

      return createTokenData;
    }() // This is a promise-based function that accepts an object as input. The
    // object is converted to JSON and uploaded to the P2WDB.

  }, {
    key: "writeJsonToP2wdb",
    value: function () {
      var _writeJsonToP2wdb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(inObj) {
        var appId, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                appId = 'token-data-001';
                console.log('Initializing wallet'); // Refresh the UTXOs in the wallet
                // await this.write.bchWallet.initialize()

                _context2.next = 5;
                return this.wallet.initialize();

              case 5:
                console.log('finished initializing wallet. Posting entry.');
                _context2.next = 8;
                return this.write.postEntry(inObj, appId);

              case 8:
                result = _context2.sent;
                return _context2.abrupt("return", result.hash);

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in slp-mutable-data/data.js writeJsonToP2wdb()');
                throw _context2.t0;

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12]]);
      }));

      function writeJsonToP2wdb(_x2) {
        return _writeJsonToP2wdb.apply(this, arguments);
      }

      return writeJsonToP2wdb;
    }() // This is a promise-based function that accepts an object as input.
    // The inObj expects a zcid property. This is the P2WDB CID used to retrieve
    // a JSON entry from the P2WDB. That JSON is extracted and pinned via the
    // P2WDB Pinning Service to a single IPFS node.
    //
    // Once the JSON is pinned, a second P2WDB write pins the JSON across the
    // entire cluster of P2WDB Pinning Service nodes.
    //
    // The promise resolves into a P2WDB zcid of the pin request.

  }, {
    key: "pinJson",
    value: function () {
      var _pinJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(inObj) {
        var zcid, cid, result, ipfsCid, p2wdbPinCid;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                zcid = inObj.zcid; // Refresh the UTXOs in the wallet
                // await this.pin.bchWallet.initialize()

                _context3.next = 4;
                return this.wallet.initialize();

              case 4:
                _context3.next = 6;
                return this.pin.json(zcid);

              case 6:
                cid = _context3.sent;
                _context3.next = 9;
                return this.pin.cid(cid);

              case 9:
                result = _context3.sent;
                // console.log('pinJson() result: ', result)
                ipfsCid = cid;
                p2wdbPinCid = result.hash;
                return _context3.abrupt("return", {
                  ipfsCid: ipfsCid,
                  p2wdbPinCid: p2wdbPinCid
                });

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](0);
                console.error('Error in slp-mutable-data/data.js pinJson()');
                throw _context3.t0;

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 15]]);
      }));

      function pinJson(_x3) {
        return _pinJson.apply(this, arguments);
      }

      return pinJson;
    }() // This function writes data to the OP_RETURN of a transaction. This is used
    // to update the mutable data of a token, by writing the CID of the new update
    // to the BCH address identified with mutable data (the MDA).
    //
    // If the WIF is not specified, the WIF from the instance of minimal-slp-wallet
    // will be used.

  }, {
    key: "writeCIDToOpReturn",
    value: function () {
      var _writeCIDToOpReturn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cid, wif) {
        var ecPair, address, utxos, utxo, transactionBuilder, originalAmount, vout, txid, txFee, remainder, ts, script, data, redeemScript, tx, hex;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!(!cid || typeof cid !== 'string')) {
                  _context4.next = 3;
                  break;
                }

                throw new Error('CID of IPFS or Filecoin data required');

              case 3:
                _context4.next = 5;
                return this.wallet.walletInfoPromise;

              case 5:
                // If WIF is not specified, use the WIF from the wallet used to
                // initialize this library.
                if (!wif) {
                  wif = this.wallet.walletInfo.privateKey;
                } // Generate a key pair from the wif.


                ecPair = this.bchjs.ECPair.fromWIF(wif);
                address = this.bchjs.ECPair.toCashAddress(ecPair);
                console.log("Updating mutable data for ".concat(address)); // Get UTXOs controlled by this address.
                // const utxos = await this.bchjs.Utxo.get(address)

                _context4.next = 11;
                return this.wallet.getUtxos(address);

              case 11:
                utxos = _context4.sent;
                _context4.next = 14;
                return this.bchjs.Utxo.findBiggestUtxo(utxos.bchUtxos);

              case 14:
                utxo = _context4.sent;
                // console.log(`utxo: ${JSON.stringify(utxo, null, 2)}`)
                // instance of transaction builder
                transactionBuilder = new this.bchjs.TransactionBuilder();
                originalAmount = utxo.value;
                vout = utxo.tx_pos;
                txid = utxo.tx_hash; // add input with txid and index of vout

                transactionBuilder.addInput(txid, vout); // Set the transaction fee. Manually set for ease of example.

                txFee = 550; // amount to send back to the sending address.
                // Subtract two dust transactions for minting baton and tokens.

                remainder = originalAmount - 500 - txFee; // console.log(`remainder: ${remainder}`)

                if (!(remainder < 546)) {
                  _context4.next = 24;
                  break;
                }

                throw new Error("Biggest UTXO for ".concat(address, " is not big enough. remainder: ").concat(remainder));

              case 24:
                ts = new Date();
                ts = ts.getTime(); // Generate the OP_RETURN data

                script = [this.bchjs.Script.opcodes.OP_RETURN, Buffer.from(JSON.stringify({
                  cid: cid,
                  ts: ts
                }))]; // Compile the script array into a bitcoin-compliant hex encoded string.

                data = this.bchjs.Script.encode(script); // Add the OP_RETURN output.

                transactionBuilder.addOutput(data, 0); // Send change back to originating address.

                transactionBuilder.addOutput(address, remainder); // Sign the transaction with the HD node.

                transactionBuilder.sign(0, ecPair, redeemScript, transactionBuilder.hashTypes.SIGHASH_ALL, originalAmount); // build tx

                tx = transactionBuilder.build(); // output rawhex

                hex = tx.toHex();
                return _context4.abrupt("return", hex);

              case 36:
                _context4.prev = 36;
                _context4.t0 = _context4["catch"](0);
                console.error('Error in writeCIDToOpReturn: ', _context4.t0);
                throw _context4.t0;

              case 40:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 36]]);
      }));

      function writeCIDToOpReturn(_x4, _x5) {
        return _writeCIDToOpReturn.apply(this, arguments);
      }

      return writeCIDToOpReturn;
    }() // Instantiate the retry-queue library, which is an ESM library,
    // and needs to be loaded with dynamic import.
    // async loadRetryQueueLib () {
    //   if (!this.retryQueue) {
    //     const retryQueueLib = await import('@chris.troutner/retry-queue')
    //     const RetryQueue = retryQueueLib.default
    //     this.retryQueue = new RetryQueue({ retryPeriod: 2000, attempts: 3 })
    //   }
    // }

  }]);

  return Data;
}();

module.exports = Data;